import e from "../../../../../../_virtual/index3.js";
import { selectorSpecificity } from "../../../../@csstools_selector-specificity@5.0.0_postcss-selector-parser@7.1.1/node_modules/@csstools/selector-specificity/dist/index.js";
import { resolveNestedSelector } from "../../../../@csstools_selector-resolve-nested@3.1.0_postcss-selector-parser@7.1.1/node_modules/@csstools/selector-resolve-nested/dist/index.js";
const r = e.pseudo({ value: ":is" });
function sortCompoundSelectorsInsideComplexSelector(t) {
  if (!t || !t.nodes) return;
  const n = [];
  let o2 = [];
  for (let s3 = 0; s3 < t.nodes.length; s3++) if ("combinator" !== t.nodes[s3].type) if (e.isPseudoElement(t.nodes[s3])) n.push(o2), o2 = [t.nodes[s3]];
  else {
    if ("tag" === t.nodes[s3].type && o2.find(((e2) => "tag" === e2.type))) {
      const n2 = r.clone({}), o3 = t.nodes[s3];
      o3.replaceWith(n2), n2.append(e.selector({ nodes: [o3], value: void 0 }));
    }
    o2.push(t.nodes[s3]);
  }
  else n.push(o2), n.push([t.nodes[s3]]), o2 = [];
  n.push(o2);
  const s2 = [];
  for (let e2 = 0; e2 < n.length; e2++) {
    const t2 = n[e2];
    t2.sort(((e3, t3) => "selector" === e3.type && "selector" === t3.type && e3.nodes.length && t3.nodes.length ? selectorTypeOrder(e3.nodes[0]) - selectorTypeOrder(t3.nodes[0]) : "selector" === e3.type && e3.nodes.length ? selectorTypeOrder(e3.nodes[0]) - selectorTypeOrder(t3) : "selector" === t3.type && t3.nodes.length ? selectorTypeOrder(e3) - selectorTypeOrder(t3.nodes[0]) : selectorTypeOrder(e3) - selectorTypeOrder(t3)));
    for (let e3 = 0; e3 < t2.length; e3++) s2.push(t2[e3]);
  }
  t.removeAll();
  for (let e2 = s2.length - 1; e2 >= 0; e2--) s2[e2].remove(), s2[e2].parent = t, t.nodes.unshift(s2[e2]);
}
function selectorTypeOrder(t) {
  return e.isPseudoElement(t) ? o.pseudoElement : o[t.type];
}
const o = { universal: 0, tag: 1, pseudoElement: 2, id: 3, class: 4, attribute: 5, pseudo: 6, selector: 7, string: 8, root: 9, comment: 10 };
function isAtRule(e2) {
  return e2 && "atrule" === e2.type;
}
function isNestRule(e2) {
  return e2 && isAtRule(e2) && "nest" === e2.name;
}
function isRule(e2) {
  return e2 && "rule" === e2.type;
}
function ampersandToScope$1(t, n) {
  let r2, o2 = t.parent;
  for (; o2; ) {
    if ("rule" === o2.type) return;
    if (isAtRule(o2) && "scope" === o2.name) return;
    o2 = o2.parent;
  }
  try {
    r2 = e().astSync(t.selector);
  } catch (e2) {
    return void t.warn(n, `Failed to parse selector : "${t.selector}" with message: "${e2 instanceof Error ? e2.message : e2}"`);
  }
  r2 && (r2.walkNesting(((t2) => {
    const n2 = t2.parent;
    t2.replaceWith(e.pseudo({ value: ":scope" })), n2 && sortCompoundSelectorsInsideComplexSelector(n2);
  })), t.selector = r2.toString());
}
function cleanupParent(e2) {
  if (!e2.nodes.length) return void e2.remove();
  const t = e2.nodes.filter(((e3) => "comment" === e3.type));
  t.length === e2.nodes.length && e2.replaceWith(...t);
}
function groupDeclarations(e2) {
  const t = [], n = [];
  e2.each(((e3) => {
    if (isDeclarationLike(e3, n.length > 0)) t.push(e3);
    else {
      if ("comment" === e3.type) {
        let r2 = e3.next();
        for (; r2 && "comment" === r2.type; ) r2 = r2.next();
        if (isDeclarationLike(r2, n.length > 0)) return void t.push(e3);
      }
      n.push(e3);
    }
  })), e2.removeAll(), t.forEach(((t2) => {
    e2.append(t2);
  })), n.forEach(((t2) => {
    e2.append(t2);
  }));
}
function isDeclarationLike(e2, t) {
  return !!e2 && ("decl" === e2.type || "atrule" === e2.type && "mixin" === e2.name.toLowerCase() && !t);
}
function comma(e2) {
  const t = [];
  let n = "", r2 = false, o2 = 0, s2 = false, i2 = false;
  for (const l of e2) i2 ? i2 = false : "\\" === l ? i2 = true : s2 ? l === s2 && (s2 = false) : '"' === l || "'" === l ? s2 = l : "(" === l ? o2 += 1 : ")" === l ? o2 > 0 && (o2 -= 1) : 0 === o2 && "," === l && (r2 = true), r2 ? ("" !== n && t.push(n.trim()), n = "", r2 = false) : n += l;
  return t.push(n.trim()), t;
}
function shiftNodesBeforeParent(e2, t) {
  const n = t.index(e2);
  if (n) {
    const e3 = t.cloneBefore().removeAll().append(t.nodes.slice(0, n));
    e3.raws.semicolon = true, cleanupParent(e3);
  }
  t.before(e2), t.raws.semicolon = true;
}
var s = ["container", "document", "media", "supports", "layer", "starting-style"];
function transformAtruleWithinAtrule(e2, t) {
  var n, r2;
  groupDeclarations(t), shiftNodesBeforeParent(e2, t), e2.params = (n = t.params, r2 = e2.params, comma(n).map(((e3) => comma(r2).map(((t2) => `${e3} and ${t2}`)).join(", "))).join(", ")), cleanupParent(t);
}
function isAtruleWithinAtrule(e2, t) {
  return s.includes(e2.name) && e2.name === t.name;
}
function atruleWithinRule$1(e2, t, n, r2, o2) {
  if (groupDeclarations(t), shiftNodesBeforeParent(e2, t), e2.nodes) {
    const s2 = t.clone().removeAll().append(e2.nodes);
    e2.append(s2), cleanupParent(t), r2(s2, n, o2);
  } else cleanupParent(t);
}
function isAtruleWithinRule$1(e2) {
  return s.includes(e2.name);
}
function combinationsWithSizeN(e2, t) {
  if (t < 2) throw new Error("n must be greater than 1");
  if (e2.length < 2) throw new Error("s must be greater than 1");
  if (Math.pow(e2.length, t) > 1e4) throw new Error("Too many combinations when trying to resolve a nested selector with lists, reduce the complexity of your selectors");
  const n = [];
  for (let e3 = 0; e3 < t; e3++) n[e3] = 0;
  const r2 = [];
  for (; ; ) {
    const o2 = [];
    for (let s2 = t - 1; s2 >= 0; s2--) {
      let t2 = n[s2];
      if (t2 >= e2.length) {
        if (t2 = 0, n[s2] = 0, 0 === s2) return r2;
        n[s2 - 1] += 1;
      }
      o2[s2] = e2[t2].clone();
    }
    r2.push(o2), n[n.length - 1]++;
  }
}
function nodesAreEquallySpecific(n) {
  const r2 = n.map(((t) => e().astSync(t))).map(((e2) => selectorSpecificity(e2))), o2 = r2[0];
  for (let e2 = 1; e2 < r2.length; e2++) if (o2.a !== r2[e2].a || o2.b !== r2[e2].b || o2.c !== r2[e2].c) return false;
  return true;
}
function mergeSelectors$1(t, n, r2) {
  let o2 = [];
  o2 = nodesAreEquallySpecific(t) || r2.noIsPseudoSelector ? t.map(((t2) => e().astSync(t2))) : [e().astSync(`:is(${t.join(",")})`)];
  const s2 = [];
  for (let t2 = 0; t2 < n.length; t2++) {
    let i2, l = n[t2];
    {
      const t3 = e().astSync(l);
      let n2 = false;
      t3.walk(((e2) => {
        "nesting" === e2.type && (n2 = true);
      }));
      const r3 = t3.nodes[0];
      let o3 = false;
      r3.each(((e2) => "combinator" === e2.type && (o3 = true, false))), n2 ? o3 && r3.insertBefore(r3.at(0), e.nesting()) : (r3.insertBefore(r3.at(0), e.combinator({ value: " " })), r3.insertBefore(r3.at(0), e.nesting())), l = t3.toString();
    }
    let c = [], a = 0;
    if (e().astSync(l).walkNesting((() => {
      a++;
    })), a > 1 && o2.length > 1) c = combinationsWithSizeN(o2, a), i2 = c.length;
    else {
      i2 = o2.length;
      for (let e2 = 0; e2 < o2.length; e2++) {
        c.push([]);
        for (let t3 = 0; t3 < a; t3++) c[e2].push(o2[e2]);
      }
    }
    for (let t3 = 0; t3 < i2; t3++) {
      let n2 = 0;
      const o3 = e().astSync(l);
      o3.walk(((o4) => {
        if ("nesting" !== o4.type) return;
        let s3 = c[t3][n2];
        n2++, "root" === s3.type && 1 === s3.nodes.length && (s3 = s3.nodes[0]);
        const i3 = e().astSync(`:is(${s3.toString()})`), l2 = isSimpleSelector(s3.nodes[0]), a2 = isCompoundSelector(s3.nodes[0]), u = isSimpleSelector(o4), p = isCompoundSelector(o4);
        if (l2 && u) return void o4.replaceWith(s3.clone());
        if ((l2 || a2) && (u || p)) {
          const e2 = o4.parent;
          return l2 && "selector" === s3.type ? o4.replaceWith(s3.clone().nodes[0]) : o4.replaceWith(...s3.clone().nodes), void (e2 && e2.nodes.length > 1 && sortCompoundSelectorsInsideComplexSelector(e2));
        }
        if (l2) {
          const e2 = o4.parent;
          return o4.replaceWith(s3.clone().nodes[0]), void (e2 && sortCompoundSelectorsInsideComplexSelector(e2));
        }
        if (a2) {
          const e2 = o4.parent;
          return o4.replaceWith(...s3.clone().nodes), void (e2 && sortCompoundSelectorsInsideComplexSelector(e2));
        }
        if (nestingIsFirstAndOnlyInSelectorWithEitherSpaceOrChildCombinator(o4)) {
          const e2 = o4.parent;
          return o4.replaceWith(...s3.clone().nodes), void (e2 && sortCompoundSelectorsInsideComplexSelector(e2));
        }
        if (nestingIsNotInsideCompoundSelector(o4)) {
          const e2 = o4.parent;
          return o4.replaceWith(...s3.clone().nodes), void (e2 && sortCompoundSelectorsInsideComplexSelector(e2));
        }
        const d = o4.parent;
        r2.noIsPseudoSelector ? o4.replaceWith(...s3.clone().nodes) : o4.replaceWith(...i3.clone({}).nodes), d && sortCompoundSelectorsInsideComplexSelector(d);
      })), s2.push(o3.toString());
    }
  }
  return s2;
}
function isSimpleSelector(e2) {
  return "combinator" !== e2.type && !(e2.parent && e2.parent.nodes.length > 1);
}
function isCompoundSelector(e2, t = null) {
  if (isSimpleSelector(e2)) return false;
  if (!e2.parent) return false;
  if (!!e2.parent.nodes.find(((e3) => "combinator" === e3.type))) return false;
  return !(!!e2.parent.nodes.find(((e3) => "nesting" === e3.type)) && t && !isCompoundSelector(t));
}
function nestingIsFirstAndOnlyInSelectorWithEitherSpaceOrChildCombinator(e2) {
  if (!e2.parent) return false;
  if (0 !== e2.parent.nodes.indexOf(e2)) return false;
  for (let t = 1; t < e2.parent.nodes.length; t++) if ("combinator" === e2.parent.nodes[t].type && " " !== e2.parent.nodes[t].value && ">" !== e2.parent.nodes[t].value) return false;
  return true;
}
function nestingIsNotInsideCompoundSelector(e2) {
  if (isSimpleSelector(e2)) return true;
  if (!e2.parent) return false;
  for (let t = 0; t < e2.parent.nodes.length; t++) if ("nesting" !== e2.parent.nodes[t].type && (e2.parent.nodes[t].prev() || e2.parent.nodes[t].next())) {
    if (e2.parent.nodes[t].prev() && "combinator" !== e2.parent.nodes[t].prev().type) return false;
    if (e2.parent.nodes[t].next() && "combinator" !== e2.parent.nodes[t].next().type) return false;
  }
  return true;
}
function transformNestRuleWithinRule(e2, t, n, r2, o2) {
  let s2 = [];
  try {
    s2 = mergeSelectors$1(t.selectors, comma(e2.params), o2);
  } catch (r3) {
    return void e2.warn(n, `Failed to parse selectors : "${t.selector}" / "${e2.params}" with message: "${r3 instanceof Error ? r3.message : r3}"`);
  }
  if (!s2.length) return;
  shiftNodesBeforeParent(e2, t);
  const i2 = t.clone().removeAll().append(e2.nodes);
  i2.raws.semicolon = true, i2.selectors = s2, e2.replaceWith(i2), cleanupParent(t), r2(i2, n, o2);
}
function isValidNestRuleWithinRule(e2) {
  return comma(e2.params).every(((e3) => e3.split("&").length >= 2 && -1 === e3.indexOf("|")));
}
function transformRuleWithinRule$1(e2, t, n, r2) {
  let o2 = [];
  try {
    o2 = mergeSelectors$1(t.selectors, e2.selectors, r2);
  } catch (r3) {
    return void e2.warn(n, `Failed to parse selectors : "${t.selector}" / "${e2.selector}" with message: "${r3 instanceof Error ? r3.message : r3}"`);
  }
  if (!o2.length) return;
  groupDeclarations(t), shiftNodesBeforeParent(e2, t), e2.selectors = o2;
  "rule" === e2.type && "rule" === t.type && e2.selector === t.selector && e2.append(...t.nodes), cleanupParent(t);
}
function isValidRuleWithinRule$1(e2) {
  return e2.selectors.every(((e3) => -1 === e3.indexOf("|")));
}
function walk$1(e2, t, n) {
  e2.each(((r2) => {
    const o2 = r2.parent;
    isNestRule(r2) && !n.silenceAtNestWarning && e2.warn(t, `\`@nest\` was removed from the CSS Nesting specification and will be removed from PostCSS Nesting in the next major version.
Change \`@nest ${r2.params} {}\` to \`${r2.params} {}\` to migrate to the latest standard.`), isRule(r2) && isRule(o2) && isValidRuleWithinRule$1(r2) ? transformRuleWithinRule$1(r2, o2, t, n) : isNestRule(r2) && isRule(o2) && isValidNestRuleWithinRule(r2) ? transformNestRuleWithinRule(r2, o2, t, walk$1, n) : isAtRule(r2) && isRule(o2) && isAtruleWithinRule$1(r2) ? atruleWithinRule$1(r2, o2, t, walk$1, n) : isAtRule(r2) && isAtRule(o2) && isAtruleWithinAtrule(r2, o2) && transformAtruleWithinAtrule(r2, o2), "nodes" in r2 && r2.nodes.length && walk$1(r2, t, n);
  }));
}
const creator$2 = (e2) => {
  const t = Object.assign({ noIsPseudoSelector: false, silenceAtNestWarning: false }, e2);
  return { postcssPlugin: "postcss-nesting", Rule(e3, { result: n }) {
    walk$1(e3, n, t), e3.selector.includes("&") && ampersandToScope$1(e3, n);
  } };
};
creator$2.postcss = true;
const i = e();
function mergeSelectors(e2, t, r2, o2) {
  let s2;
  try {
    s2 = resolveNestedSelector(i.astSync(t), i.astSync(r2));
  } catch (n) {
    return e2.warn(o2, `Failed to parse selectors : "${r2}" / "${t}" with message: "${n instanceof Error ? n.message : n}"`), false;
  }
  return !!s2 && s2.toString();
}
function ampersandToScope(t, n) {
  {
    let r3 = t.parent;
    for (; r3; ) {
      if ("rule" === r3.type) return;
      if (isAtRule(r3) && "scope" === r3.name) return;
      r3 = r3.parent;
    }
    try {
      let n2 = false;
      if (e().astSync(t.selector).walkNesting((() => (n2 = true, false))), !n2) return;
    } catch (e2) {
      return void t.warn(n, `Failed to parse selector : "${t.selector}" with message: "${e2 instanceof Error ? e2.message : e2}"`);
    }
  }
  const r2 = mergeSelectors(t, t.selector, ":scope", n);
  r2 && (t.selector = r2);
}
function atruleWithinRule(e2, t, n, r2) {
  if (shiftNodesBeforeParent(e2, t), e2.nodes) {
    const o2 = t.clone().removeAll().append(e2.nodes);
    e2.append(o2), cleanupParent(t), r2(o2, n);
  } else cleanupParent(t);
}
function isAtruleWithinRule(e2) {
  return s.includes(e2.name);
}
function transformRuleWithinRule(e2, t, n) {
  const r2 = mergeSelectors(e2, e2.selector, t.selector, n);
  if (!r2) return;
  shiftNodesBeforeParent(e2, t), e2.selector = r2;
  "rule" === e2.type && "rule" === t.type && e2.selector === t.selector && e2.append(...t.nodes), cleanupParent(t);
}
function isValidRuleWithinRule(e2) {
  return e2.selectors.every(((e3) => -1 === e3.indexOf("|")));
}
function walk(e2, t) {
  e2.each(((e3) => {
    const n = e3.parent;
    isRule(e3) && isRule(n) && isValidRuleWithinRule(e3) ? transformRuleWithinRule(e3, n, t) : isAtRule(e3) && isRule(n) && isAtruleWithinRule(e3) && atruleWithinRule(e3, n, t, walk), "nodes" in e3 && e3.nodes.length && walk(e3, t);
  }));
}
const creator$1 = () => ({ postcssPlugin: "postcss-nesting", Rule(e2, { result: t }) {
  walk(e2, t), e2.selector.includes("&") && ampersandToScope(e2, t);
}, AtRule: { nest(e2) {
  throw e2.error(`\`@nest\` was removed from the CSS Nesting specification and will be removed from PostCSS Nesting in the next major version.
Change \`@nest ${e2.params} {}\` to \`${e2.params} {}\` to migrate to the latest standard.`);
} } });
creator$1.postcss = true;
const creator = (e2) => {
  const t = Object.assign({ edition: "2024-02" }, e2);
  switch (t.edition) {
    case "2021":
      return creator$2(e2);
    case "2024-02":
      return creator$1();
    default:
      throw new Error(`Invalid edition: ${t.edition}`);
  }
};
creator.postcss = true;
export {
  creator as default
};
//# sourceMappingURL=index.js.map
